import { Link } from "react-router-dom";
import { ShoppingCart } from "@phosphor-icons/react";
import { toast } from "sonner";
import { formatPrice } from "../lib/api";
import { useCart } from "../context/CartContext";

export const ProductCard = ({ product }) => {
  const { addItem } = useCart();
  const bestTier = product.price_tiers[product.price_tiers.length - 1];
  const hasVolume = product.price_tiers.length > 1;

  return (
    <div data-testid={`product-card-${product.sku}`} className="card-industrial group flex flex-col border border-border bg-white">
      <Link to={`/produkts/${product.slug}`} className="block">
        <div className="aspect-square overflow-hidden bg-[#F4F5F7] border-b border-border">
          <img src={product.image} alt={product.name} loading="lazy" className="h-full w-full object-cover" />
        </div>
      </Link>
      <div className="flex flex-1 flex-col p-3 md:p-4">
        <p className="text-xs font-bold tracking-[0.15em] uppercase text-slate-500">{product.brand}</p>
        <Link to={`/produkts/${product.slug}`} className="mt-1 text-sm font-semibold leading-snug hover:text-[#2E86D1] line-clamp-2 min-h-[2.5rem]">
          {product.name}
        </Link>
        <p className="mt-1 text-xs text-slate-500">Art. {product.sku}</p>
        <div className="mt-auto pt-3">
          <div className="flex items-end justify-between gap-2">
            <div>
              <p data-testid={`product-price-${product.sku}`} className="text-lg font-black font-heading">{formatPrice(product.price_tiers[0].price)}</p>
              <p className="text-[11px] text-slate-500">bez PVN{hasVolume && <span className="text-[#16A34A] font-semibold"> · no {formatPrice(bestTier.price)} vairumā</span>}</p>
            </div>
            <button
              data-testid={`add-to-cart-${product.sku}`}
              aria-label="Pievienot grozam"
              onClick={() => { addItem(product, 1); toast.success("Pievienots grozam", { description: product.name }); }}
              className="btn-industrial h-9 w-9 flex items-center justify-center bg-[#1D1D1F] text-white hover:bg-[#2E86D1]"
            >
              <ShoppingCart size={18} />
            </button>
          </div>
          <p className={`mt-2 text-[11px] font-semibold ${product.stock > 0 ? "text-[#16A34A]" : "text-[#2E86D1]"}`}>
            {product.stock > 0 ? `Noliktavā: ${product.stock} gab` : "Nav noliktavā"}
          </p>
        </div>
      </div>
    </div>
  );
};
